<ng-container *transloco="let t; read: 'profile'">
<h1 class="mbm">{{ t('title') }} {{(currentEmployee$ | async)?.firstName}} {{(currentEmployee$ | async)?.lastName}}</h1>

<h3 class="pbs">{{ t('information') }}</h3>
<table class="mbs">
    <tr *ngIf="(currentEmployee$ | async)?.employeeRole">
        <td class="prs">{{ t('employeeRole') }}</td>
        <td>{{(currentEmployee$ | async)?.employeeRole.name}}</td>
    </tr>
    <tr *ngIf="(currentEmployee$ | async)?.department">
        <td class="prs">{{ t('department') }}</td>
        <td>{{(currentEmployee$ | async)?.department.name}}</td>
    </tr>
    <tr *ngIf="(currentEmployee$ | async)?.email">
        <td class="prs">{{ t('email') }}</td>
        <td>{{(currentEmployee$ | async)?.email}}</td>
    </tr>
</table>

<h3 class="mbs mtm">{{ t('changePassword') }}</h3>
<form class="k-form" [formGroup]="form" (ngSubmit)="onSubmit()">

    <kendo-formfield class="mbs">
        <kendo-label [for]="password" [text]="t('currentPassword')"></kendo-label>
        <input
            kendoTextBox
            [style.width.px]="350"
            type="password"
            formControlName="password"
            #password
            required
            [minlength]="6"
        >

        <kendo-formhint>{{ t('currentPasswordHint') }}</kendo-formhint>
        <kendo-formerror>{{ t('passwordError') }}</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield class="mbs">
        <kendo-label [for]="newPassword" [text]="t('newPassword')"></kendo-label>
        <input
            kendoTextBox
            [style.width.px]="350"
            type="password"
            formControlName="newPassword"
            #newPassword
            required
            [minlength]="6"
        >

        <kendo-formhint>{{ t('newPasswordHint') }}</kendo-formhint>
        <kendo-formerror>{{ t('passwordError') }}</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield class="mbs">
        <kendo-label [for]="confirmNewPassword" [text]="t('confirmNewPassword')"></kendo-label>
        <input
            kendoTextBox
            [style.width.px]="350"
            type="password"
            formControlName="confirmNewPassword"
            #confirmNewPassword
            required
            [minlength]="6"
        >

        <kendo-formhint>{{ t('confirmNewPasswordHint') }}</kendo-formhint>
        <kendo-formerror>{{ t('confirmPasswordError') }}</kendo-formerror>
    </kendo-formfield>

    <button
      kendoButton
      themeColor="primary"
      [disabled]="!form.valid"
      type="submit"
    >
        {{ t('submitPassword') }}
    </button>
  </form>
</ng-container>
